import React from 'react'
import nullImg from '../assets/null.png'

const NullData = function () {
  return (
    <div className="flex flex-col gap-4 pt-4 items-center justify-center mx-auto">
      <img
        src={nullImg}
        alt="null"
        style={{ width: '300px', height: '160px' }}
      />
      <div style={{ color: '#389EF2' }}>暂无数据</div>
    </div>
  )
}

export default NullData
